import { render, staticRenderFns } from "./TemplateFTLClient.vue?vue&type=template&id=2f1b84ac&scoped=true&"
import script from "./TemplateFTLClient.vue?vue&type=script&lang=js&"
export * from "./TemplateFTLClient.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFTLClient.vue?vue&type=style&index=0&id=2f1b84ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b84ac",
  null
  
)

export default component.exports